import React from 'react';
import Image from 'next/image';

import './ArticleCta.css';

export default function ArticleCta(props: { data: any }) {
  const { data } = props;
  const { button1Type, button1Text, button1Url, button2Type, button2Text, button2Url } = data;

  const button1TypeLower = button1Type?.toLowerCase()?.replace(' ', '-');
  const button2TypeLower = button2Type?.toLowerCase()?.replace(' ', '-');

  return (
    <div className="article-cta">
      {button1Type && button1Text && button1Url && (
        <a href={button1Url} className={`t2-button t2-button--medium t2-button--${button1TypeLower}`}>
          { button1Type == 'Apple Store' ? ( <Image src="/apple.webp" alt="Apple" className="mr-2" width={200} height={20} /> ) :
            button1Type == 'Google Play' ? ( <Image src="/play.webp" alt="Google" className="mr-2" width={200} height={20} /> ) :
            button1Text  
          }
        </a>
      )}
      {button2Type && button2Text && button2Url && (
        <a href={button2Url} className={`t2-button t2-button--medium t2-button--${button2TypeLower}`}>
          { button2Type == 'Apple Store' ? ( <Image src="/apple.webp" alt="Apple" className="mr-2" width={200} height={20} /> ) :
            button2Type == 'Play Store' ? ( <Image src="/play.webp" alt="Google" className="mr-2" width={200} height={20} /> ) :
            button2Text  
          }
        </a>
      )}
    </div>
  );
}